import { OrgStructureEmployee } from "./OrgStructureEmployee";

export class OrgStructureReportUnit {
  public orgUnitId: number;
  public orgUnitName: string;
  public children: OrgStructureReportUnit[];
  public chief: OrgStructureEmployee[];
  public employees: OrgStructureEmployee[];
}
